(function (Drupal) {
  if (typeof Drupal.checkPlain === 'function') {
    const _orig = Drupal.checkPlain;
    Drupal.checkPlain = function (text) {
      // Safely coerce null/undefined → empty string
      if (text == null) {
        return '';
      }
      return _orig(text);
    };
  }
})(Drupal);
